<template>
    <div class="main">
        <h2>{{title}}</h2>
        <p>{{text}}
        </p>
        <img :src="image">
    </div>
</template>

<script>
    export default {
        name: "web-intro-page",
        data() {
            return {
            }
        },
        props:{
            title:String,
            text:String,
            image:String,
        },
        methods:{}
        ,
        //todo: добавить сторонние компоненты через import
    }
</script>

<style scoped>
    .main {
        text-align: center;
    }

    .homeModal h2,p,div,img{
        margin: 10px;
    }
    .homeModal h2{
        color:#29b6f6;
    }
    .modalFooter *{
        display: inline-block;
    }
</style>